import { render, staticRenderFns } from "./d-leaderboard-feed-search.vue?vue&type=template&id=89d27814&"
import script from "./d-leaderboard-feed-search.vue?vue&type=script&lang=js&"
export * from "./d-leaderboard-feed-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports